const chunk = require('lodash/chunk')
const filter = require('lodash/filter')
const isArray = require('lodash/isArray')
const isString = require('lodash/isString')
const orderBy = require('lodash/orderBy')
const reject = require('lodash/reject')
const sample = require('lodash/sample')
const sampleSize = require('lodash/sampleSize')
const shuffle = require('lodash/shuffle')

/**
 * Collections plugin
 */
export default function install (Vue, options) {
  Vue.mixin({
    data: function () {
      return {
        collections: {}
      }
    },

    watch: {
      '$route.path' () {
        this._importCollections()
      }
    },

    created () {
      this._importCollections()
    },

    methods: {
      _importCollections () {
        if (!this.$options.importCollections) return

        const _this = this

        // Import collections
        this.$options.importCollections.forEach(function (collection) {
          // Create a collection definition object if a simple name is passed:
          if (isString(collection)) collection = { name: collection }

          // Set the collection on the data object right away
          _this.$set(_this.collections, collection.name, { items: {} })

          // Async import the collection
          import('app/.generated/collections/' + collection.name + '.json')
            .then(data => {
              // Apply orderBy
              if (collection.orderBy) {
                data.items = isArray(collection.orderBy)
                  ? orderBy(data.items, collection.orderBy[0], collection.orderBy[1])
                  : orderBy(data.items, collection.orderBy)
              }

              // Apply sample
              if (collection.sample) data.items = [ sample(data.items) ]

              // Apply sample size
              if (collection.sampleSize) data.items = sampleSize(data.items, collection.sampleSize)

              // Apply shuffle
              if (collection.shuffle) data.items = shuffle(data.items)

              // Apply filter
              if (collection.filter) data.items = filter(data.items, collection.filter.bind(_this))

              // Apply reject
              if (collection.reject) data.items = reject(data.items, collection.reject)

              // Apply chunk
              if (collection.chunk) {
                // Transform to array if necessary
                if (!isArray(data.items)) data.items = orderBy(data.items)
                data.items = chunk(data.items, collection.chunk)
              }

              _this.$set(_this.collections, collection.name, data)
            })
            .catch(err => {
              console.error(`There was a problem retrieving the ${collection.name} collection. Did you define it in config/collections.yaml?`)
              console.error(err)
            })
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./app/src/plugins/collections.js